import { ToolbarIconInfo } from '@Primitive/ToolbarIconButton';
import type { ExcelOptions } from '../TimeSeriesStructs';
import { JsonSchemaValidator } from '@Utils/JsonSchemaValidator';
// -------------------------------------------------------------------------------------------------
export enum am4ChartsTheme {
    material = "material",
    amchartsdark = "amchartsdark",
    amcharts = "amcharts",
    dark = "dark",
    dataviz = "dataviz",
    frozen = "frozen",
    kelly = "kelly",
    microchart = "microchart",
    moonrisekingdom = "moonrisekingdom",
    patterns = "patterns",
    spiritedaway = "spiritedaway"
}
// -------------------------------------------------------------------------------------------------
export const enum PortKeys {
    Data = 'data',
    UpdateConfig = 'updateconfig',
    RealTime = "RealTime",
    DateRange = 'daterange',
    SelectedData = "SelectedData",
    SelectedRange = "SelectedRange",
    onToolbarIconClick = 'onToolbarIconClick',
    SelectedZoomRange = 'selectedzoomrange',
    CursorSelection = 'cursorselection'
}
// -------------------------------------------------------------------------------------------------
export interface amChartsData {
    theme: am4ChartsTheme;
    enableAnimations: boolean;
    enableClickEvents: boolean;
    enableZoomEvents: boolean;

    showDateRange: boolean;
    initialDateRangeDays: number;
    timePicker: boolean;
    timePickerIncrement: number;
    timePickerInitialRange: number;

    initialRealtimeData: boolean;
    showRealTimeFlag: boolean;

    excelDownload: boolean;
    excelOptions: ExcelOptions;

    defaultIconsColor?: string;
    customToolbarIcons: ToolbarIconInfo[];
    toolbarIconSize?: number;
    toolbarHeight?: number;
    toolbarFontColor?: string;
}
// ------------------------------------------------------------------------------------------------
export interface IAmChartPartialConfig {
    cursorBehavior: string;
    mouseWheelBehavior: string;
    mouseWheelScrollEnabled: boolean;
    scrollbarX: boolean;
    scrollbarY: boolean;
    lineSmoothing: string;
    stackBars: boolean;
    showGrid: boolean;
}
// -------------------------------------------------------------------------------------------------
export const updateConfigValidator = () => JsonSchemaValidator.GetInstance('updateConfigValidator', {
    type: 'object',
    properties: {
        cursorBehavior: {
            type: 'string',
            enum: [
                'zoomX',
                'zoomY',
                'zoomXY',
                'selectX',
                'selectY',
                'selectXY',
                'panX',
                'panY',
                'panXY',
                'none'
            ]
        },
        scrollbarX: { type: 'boolean' },
        scrollbarY: { type: 'boolean' },
        lineSmoothing: {
            type: 'string',
            enum: [
                'bezier',
                'monotoneX',
                'monotoneY'
            ]
        },
        stackBars: { type: 'boolean' },
        showGrid: { type: 'boolean' }
    }
});
// -------------------------------------------------------------------------------------------------
export interface IHitEvent {
    categoryX: any;
    categoryY: any;
    dateX: any;
    dateY: any;
    valueX: any;
    valueY: any;
    dataContext: any;
}
// -------------------------------------------------------------------------------------------------
export interface IRange {
    start: any;
    end: any;
}
// -------------------------------------------------------------------------------------------------
export interface IZoomRangeChangeEvent extends IRange { }
// -------------------------------------------------------------------------------------------------
export interface ICursorSelectionChangeEvent extends IRange { }
// -------------------------------------------------------------------------------------------------
export enum CursorBehavior {
    ZoomX = 'zoomX',
    ZoomY = 'zoomY',
    ZoomXY = 'zoomXY',
    SelectX = 'selectX',
    SelectY = 'selectY',
    SelectXY = 'selectXY',
    PanX = 'panX',
    PanY = 'panY',
    PanXY = 'panXY',
    None = 'none'
}
// -------------------------------------------------------------------------------------------------